import { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { getBrandGuideline } from "../api/brandGuidelineService";

// This belongs in the authenticated app shell so the reminder is not limited
// to a particular asset-creation tool.
export default function BrandGuidelineReminder() {
  const { authReady, isLoggedIn, subscription_id, token, user_type } = useAuth();
  const { pathname } = useLocation();
  const editingGuideline = pathname === "/home/organization/brand-guidelines";
  const [needsGuideline, setNeedsGuideline] = useState(false);

  const refreshGuidelineStatus = useCallback(() => {
    if (editingGuideline || !authReady || !isLoggedIn || !subscription_id) {
      setNeedsGuideline(false);
      return Promise.resolve();
    }

    return getBrandGuideline(subscription_id, token)
      .then((guide) => {
        setNeedsGuideline(guide?.is_configured === false);
      })
      // Do not show a misleading setup warning when the status check itself
      // failed (for example, while the session is being refreshed).
      .catch(() => setNeedsGuideline(false));
  }, [authReady, editingGuideline, isLoggedIn, subscription_id, token]);

  useEffect(() => {
    refreshGuidelineStatus();
    window.addEventListener("brand-guideline-updated", refreshGuidelineStatus);
    return () => window.removeEventListener("brand-guideline-updated", refreshGuidelineStatus);
  }, [refreshGuidelineStatus]);

  if (!needsGuideline) return null;

  return (
    <div className="relative z-50 border-b border-amber-300 bg-amber-50 px-4 py-3 text-center text-sm text-amber-950" role="alert">
      {user_type === "admin" ? (
        <>
          Please update your organization’s brand guidelines before using StunM services. <Link to="/home/organization/brand-guidelines" className="font-semibold underline">Open Brand Guidelines</Link>
        </>
      ) : (
        <>Please ask your organization admin to update the brand guidelines before using StunM services.</>
      )}
    </div>
  );
}
